'use strict';

/*
DOCUMENT ME
*/

define('modules/module.offer.generic',[
  'jquery',
  './module.static',
  'lib/util/tda.config'
], function (
  $,
  StaticModule,
  tdaConfig
) {
  var __offerUrl = function () {
    if (tdaConfig.tda.code === 'WWW') {
      return '#offers';
    }
    return '/' + tdaConfig.site.context_url + '/offers/';
  };

  var OfferGenericModule = StaticModule.extend({
    events: function () {
      return Object.assign({}, StaticModule.prototype.events, {
        'click .module-cta-0': 'onViewClicked'
      });
    },

    getTemplateContext: function () {
      return $.extend({}, OfferGenericModule.staticData.all, OfferGenericModule.staticData[this.getCanvas().getLang()], this.getConfig().data);
    },

    onViewClicked: function (e) {
      if (tdaConfig.tda.code === 'WWW') {
        e && e.preventDefault();
        // handled by zip-tools national links
      }
    }
  }, {
    // staticData is the staticProps arg of Module.extend
    staticData: {
      all: {
        image: {
          '1x1': '/assets/img/module/offers/onethird@2x.jpg',
          '2x1': '/assets/img/module/offers/twothirds@2x.jpg',
          '3x1': '/assets/img/module/offers/threethirds@2x.jpg'
        },
        subtextIcon: '/assets/img/module/offers/icon-offers.svg',
      },
      en: {
        subtext: 'Toyota Deals',
        headline: {
          '1x1': 'See Toyota Specials Nearby',
          '2x1': 'Explore Toyota Specials Near You'
        },
        copy: {
          '1x1': '<p>Find incredible Toyota lease deals, special offers and tons of Toyota incentives near you.</p>',
          '2x1': '<p>Find incredible Toyota lease deals and tons of Toyota incentives on new and certified pre-owned cars.</p>'
        },
        actions: [
          {
            title: 'Get Started',
            url: __offerUrl(),
          }
        ],
        dataLayer: {
          link_text: 'Get Started',
          list_item_index: '1',
          content_section: 'Get_Started',
        }
      },
      es: {
        subtext: 'Ofertas Toyota',
        headline: {
          '1x1': 'Ofertas especiales cerca',
          '2x1': 'Mira ofertas especiales cercanas'
        },
        copy: {
          '1x1': '<p>Encuentra ofertas de arrendamiento, incentivos y ofertas especiales Toyota cerca de ti.</p>',
          '2x1': '<p>Encuentra ofertas de arrendamiento e incentivos para Toyotas nuevos y usados certificados.</p>'
        },
        actions: [
          {
            title: 'Comienza',
            url: __offerUrl(),
          }
        ],
        dataLayer: {
          link_text: 'Comienza',
          list_item_index: '1',
          content_section: 'Get_Started',
        }
      }
    }

  });

  return OfferGenericModule;
});

